import React from 'react';
import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import AseguradoKids from 'containers/Segurykids/AseguradoKids';
import CotizacionKids from 'containers/Segurykids/CotizacionKids';
import PagadorKids from 'containers/Segurykids/PagadorKids';
import PlanPagoKids from 'containers/Segurykids/PlanPagoKids';
import PlanesKids from 'containers/Segurykids/PlanesKids';
import RecuperarPolizaKids from 'containers/Segurykids/RecuperarPolizaKids';
import RecuperarSegukids from 'containers/Segurykids/RecuperarSegukids';
import SegukisContratante from 'containers/Segurykids/SegukidsContratante';
import { SEGUKIDS } from 'containers/Segurykids/constants';

const SKT_ROUTES = [
  <LayoutRoute
    exact
    path={SEGUKIDS.urls.cotizacion}
    layout={HomePublicaLayout}
    component={CotizacionKids}
  />,
  <LayoutRoute
    exact
    path={SEGUKIDS.urls.planes}
    layout={HomePublicaLayout}
    component={PlanesKids}
  />,
  <LayoutRoute
    exact
    path={SEGUKIDS.urls.formaPago}
    layout={HomePublicaLayout}
    component={PlanPagoKids}
  />,

  <LayoutRoute
    exact
    path={SEGUKIDS.urls.asegurado}
    layout={HomePublicaLayout}
    component={AseguradoKids}
  />,
  <LayoutRoute
    exact
    path={SEGUKIDS.urls.contratante}
    layout={HomePublicaLayout}
    component={SegukisContratante}
  />,

  <LayoutRoute
    exact
    path={SEGUKIDS.urls.pagador}
    layout={HomePublicaLayout}
    component={PagadorKids}
  />,
  <LayoutRoute
    exact
    path={SEGUKIDS.urls.recuperar}
    layout={HomePublicaLayout}
    component={RecuperarSegukids}
  />,
  <LayoutRoute
    exact
    path={SEGUKIDS.urls.poliza}
    layout={HomePublicaLayout}
    component={RecuperarPolizaKids}
  />,
];

export default SKT_ROUTES;
